import { BlockIcon } from 'canoe';
import React from 'react';

import { ValueToggle } from '@candu-ai/craft/ui';

interface Props {
  flexDirection: string;
  setCss: (css: Record<string, any>) => void;
}

export const FlexDirectionColumn = ({ flexDirection, setCss }: Props) => {
  return (
    <ValueToggle
      toggleGroup="flex-direction"
      id="column"
      data-cy="toolbox-flex-direction-column"
      onClick={() => setCss({ flexDirection: 'column' })}
      isActive={flexDirection === 'column'}
      icon={BlockIcon}
      tooltip="Vertical"
      color="light"
    />
  );
};
